import { Injectable } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';
import { DialogcancelconfirmComponent } from '../dialogcancelconfirm/dialogcancelconfirm.component';

@Injectable({
  providedIn: 'root'
})
export class ConfirmdialogService {

  constructor(private dialog:MatDialog) { }

  openDialog(){
   return this.dialog.open(DialogcancelconfirmComponent);
  }
}
